import React from 'react'
import styled from 'styled-components'

export interface InputValueProps {
    value?: undefined | null | number | string
    placeholder?: string
    defaultValue?: undefined | null | number
    className?: string
    onChange?: (value: any) => void
    type?: 'number' | 'text'
}

export function InputValue({
    placeholder,
    value,
    defaultValue,
    className,
    onChange,
    type = 'number'
}: InputValueProps) {
    return (
        <InputValueContainer
            placeholder={placeholder}
            defaultValue={defaultValue}
            className={className}
            type={type}
            value={value}
            onChange={onChange}
        />
    )
}

const InputValueContainer = styled.input`
    width: 100%;
    font-size: 14px;
    box-shadow: none;

    height: 38px !important;
    /* max-width: 65% !important; // tamanho do input */
    border-right: none;
    border-radius: 3px 0 0 3px;

    :focus {
        border-right: 1px solid var(--blue-500);
    }
`
